import type { ReactNode } from "react";

import { Navigate } from "react-router-dom";

import { useAuth } from "../context/AuthContext";

export function ProtectedRoute({
  children,
}: {
  children: ReactNode;
}) {

  const {
    isAuthenticated,
    loading
  } = useAuth();

  // WAIT until auth restored
  if (loading) {

    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {

    return (
      <Navigate
        to="/admin/login"
        replace
      />
    );
  }

  return <>{children}</>;
}